import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormHelperText,
  Typography,
  Box,
} from "@mui/material";

interface Option {
  label: string;
  value: string | number;
}

interface SelectFieldProps {
  name: string,
  value: any;
  onChange: (e: any) => void;
  options: Option[];
  placeholder?: string;
  icon?: React.ReactNode;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
  name,
  value,
  onChange,
  options,
  placeholder = "Select Option",
  icon,
  label,
  required = false,
  error = false,
  helperText = "",
  disabled = false,
}) => {
  return (
    <FormControl fullWidth size="small" error={error} sx={{ flex: 1 }}>
      
      {/* 🔥 LABEL */}
      {label && (
        <Typography sx={{ fontSize: 13, mb: 0.5 }}>
          {label}
          {required && (
            <Box component="span" sx={{ color: "red", ml: 0.5 }}>
              *
            </Box>
          )}
        </Typography>
      )}

      <Select
       name={name} 
         disabled={disabled}
        value={value || ""}
        onChange={onChange}
        displayEmpty
        input={
          <OutlinedInput
            startAdornment={
              icon ? (
                <InputAdornment position="start">
                  {icon}
                </InputAdornment>
              ) : undefined
            }
            sx={{
              borderRadius: "12px",
              backgroundColor: "#f8fafc",
              height: "44px",
            }}
          />
        }
      >
        {/* Placeholder */}
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>

        {/* Options */}
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>

      {/* 🔥 ERROR TEXT */}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default SelectField;